// "Propose marriage to <name>" — a small dialog shared by the Registry page and the in-game Registry card.
// The server (server/marriage.js) decides everything that matters (genders, the Marriage License, 5 wives / 1 husband, limits); this only asks how long to keep the proposal open.

import './invites.css'
import { proposalActions, getInvites } from '../game/inviteManager.js'

const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
const DAYS_LABEL = { 1: '1 day', 3: '3 days', 7: '7 days' }

// target: { id (player id) | no (Registry number), name }. onDone(text) is called after the proposal is sent.
export function openProposeDialog({ id = null, no = null, name, onDone = () => {} }) {
  document.querySelector('.inv-layer--propose')?.remove()
  const R = getInvites().marriageRules ?? { expiresDays: [1, 3, 7], defaultExpiresDays: 3 }
  const layer = document.createElement('div'); layer.className = 'inv-layer inv-layer--propose'
  layer.innerHTML = `<div class="inv-pop"><form class="inv-card" role="dialog" aria-modal="true" aria-labelledby="prp-dlg-title">
      <div class="inv-kicker">Propose marriage</div>
      <h2 id="prp-dlg-title">${esc(name)}</h2>
      <label class="inv-field"><span>The proposal stays open for</span><select name="expiresDays">${R.expiresDays.map((d) => `<option value="${d}" ${d === R.defaultExpiresDays ? 'selected' : ''}>${DAYS_LABEL[d] ?? d + ' days'}</option>`).join('')}</select></label>
      <p class="inv-note">${esc(name)} sees it as soon as they sign in. If they accept, you stay separate players — nothing is shared except that the Registry shows you as married, with your combined wealth. A husband can see a report on each of his wives.</p>
      <p class="inv-error" data-prp-err role="alert" hidden></p>
      <div class="inv-actions"><button type="submit" class="inv-btn inv-btn--main">Send proposal</button><button type="button" class="inv-btn inv-btn--quiet" data-prp-cancel>Cancel</button></div>
    </form></div>`
  document.body.appendChild(layer)
  const close = () => layer.remove()
  layer.querySelector('select')?.focus()
  layer.addEventListener('click', (e) => { if (e.target.matches('[data-prp-cancel]') || e.target.classList.contains('inv-pop')) close() })
  layer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close() })
  layer.querySelector('form').addEventListener('submit', async (e) => {
    e.preventDefault()
    const f = e.target, btn = f.querySelector('button[type="submit"]'); btn.disabled = true
    const days = Number(f.expiresDays.value)
    try {
      await proposalActions.create({ ...(id ? { toId: id } : { toNo: no }), expiresDays: days })
      close(); onDone(`Marriage proposal sent to ${name}. It stays open for ${DAYS_LABEL[days] ?? days + ' days'}, and ${name} sees it as soon as they sign in.`)
    } catch (err) {
      const m = layer.querySelector('[data-prp-err]'); m.textContent = err?.body?.error ?? 'Could not send the proposal — try again.'; m.hidden = false; btn.disabled = false
    }
  })
}
